import { api } from '../core';

export type DocumentCreateUnassignedResponse = {
  documentId: string | null;
  unassignedDocumentId: string | null;
};

type DocumentCreateUnassignedProps = {
  documentName: string;
  documentSizeMb: number;
};

const documentCreateUnassignedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentCreateUnassigned: builder.query<DocumentCreateUnassignedResponse, DocumentCreateUnassignedProps>({
      query: ({ documentName, documentSizeMb }: DocumentCreateUnassignedProps) => ({
        url: `document/create/unassigned`,
        method: 'POST',
        body: {
          document_name: documentName,
          document_size_mb: documentSizeMb
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postDocumentCreateUnassigned in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentCreateUnassignedQuery } = documentCreateUnassignedApi;
